import React from 'react'

import { GenericOverlay } from '../Overlays'
import { ExplainerVideoStyles } from './ExplainerVideoStyles'
import { Iframe } from './Iframe'

interface PlayVideoConf {
  isMobile: boolean
  handleCloseVideo: () => void
  url: string
  iframeVideoRef: object
  triggerAutoPlay: () => void
  cookieConsent: boolean
  hideDismissIcon: boolean
}

export const VideoPlayer = ({
  handleCloseVideo,
  url,
  iframeVideoRef,
  triggerAutoPlay,
  cookieConsent = false,
  hideDismissIcon = false,
  isMobile,
}: PlayVideoConf) => {
  if (isMobile) {
    const cookieYesIcon = document.querySelector<HTMLElement>('.cky-revisit-bottom-left')
    if (cookieYesIcon) cookieYesIcon.style.display = 'none'
  }
  return (
    <ExplainerVideoStyles>
      <GenericOverlay
        overlay={<Iframe url={url} iframeVideoRef={iframeVideoRef} triggerAutoPlay={triggerAutoPlay} />}
        cookieConsent={cookieConsent}
        onClose={handleCloseVideo}
      />
    </ExplainerVideoStyles>
  )
}
